import React,{useState} from 'react';
import { FaFilter, FaTimes, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Button } from '../../../common';
import { IDENTITY_TYPES, RISK_LEVELS, STATUS, TYPE_LABELS, RISK_LABELS, STATUS_LABELS } from '../../../../utils/constants';
import './IdentityFilters.css';

/**
 * IdentityFilters Component
 * Filter controls for identity list
 */
const IdentityFilters = ({
  filters,
  onFilterChange,
  onReset,
  showTypeFilter = false,
  showStatusFilter = false,
  showRiskFilter = false,
  showAccountTypeFilter = false,
  showSort = true,
  allowedTypes
}) => {
  const handleChange = (key, value) => {
    onFilterChange({ [key]: value || null });
  };

  const handleSortToggle = () => {
    onFilterChange({
      sortOrder: filters.sortOrder === 'asc' ? 'desc' : 'asc'
    });
  };
  const [openDropdown, setOpenDropdown] = useState(null);
  const hasActiveFilters = filters.type || filters.status || filters.riskLevel;

  return (
    <div className="identity-filters">
      <div className="filters-left">
        <div className="filter-icon">
          <FaFilter />
          <span>Filters</span>
        </div>

        {showTypeFilter && (
          <select
            className="filter-select"
            value={filters.type || ''}
            onChange={(e) => handleChange('type', e.target.value)}
          >
            <option value="">All Types</option>
            {Object.entries(IDENTITY_TYPES).filter(([key, value]) =>allowedTypes ? allowedTypes.includes(value) : true
              )
              .map(([key, value]) => (
              <option key={value} value={value}>
                {TYPE_LABELS[value]}
              </option>
            ))}
          </select>
        )}

        {showStatusFilter && (
          <select
            className="filter-select"
            value={filters.status || ''}
            onChange={(e) => handleChange('status', e.target.value)}
          >
            <option value="">All Status</option>
            {Object.entries(STATUS).map(([key, value]) => (
              <option key={value} value={value}>
                {STATUS_LABELS[value]}
              </option>
            ))}
          </select>
        )}

        {showRiskFilter && (
          <select
            className="filter-select"
            value={filters.riskLevel || ''}
            onChange={(e) => handleChange('riskLevel', e.target.value)}
          >
            <option value="">All Risk Levels</option>
            {Object.entries(RISK_LEVELS).map(([key, value]) => (
              <option key={value} value={value}>
                {RISK_LABELS[value]}
              </option>
            ))}
          </select>
        )}
        

        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            icon={<FaTimes />}
            onClick={onReset}
          >
            Clear
          </Button>
        )}
      </div>

      <div className="filters-right">
        {showAccountTypeFilter && (
          <div className="custom-select-container">
      {/* The box you click */}
      <div 
        className="filter-select" 
        onClick={() => setOpenDropdown(openDropdown === 'account' ? null : 'account')}
      >
        {filters.account_type ? filters.account_type.replace('-', ' ') : "All Account Types"}
      </div>

      {/* THE DROPDOWN LIST (This is what will scroll) */}
      {openDropdown === 'account' && (
        <ul className="scrollable-options">
          <li onClick={() => { handleChange('account_type', ''); setOpenDropdown(null); }}>All Account Types</li>
          <li onClick={() => { handleChange('account_type', 'dormant'); setOpenDropdown(null); }}>Dormant Accounts</li>
          <li onClick={() => { handleChange('account_type', 'orphan'); setOpenDropdown(null); }}>Orphan Accounts</li>
          <li onClick={() => { handleChange('account_type', 'privilege'); setOpenDropdown(null); }}>Privileged Accounts</li>
          <li onClick={() => { handleChange('account_type', 'guest'); setOpenDropdown(null); }}>Guest Accounts</li>
          <li onClick={() => { handleChange('account_type', 'no-expiry'); setOpenDropdown(null); }}>Password Never Expire</li>
          <li onClick={() => { handleChange('account_type', 'new'); setOpenDropdown(null); }}>New Accounts</li>
          <li onClick={() => { handleChange('account_type', 'mfa-not-registered'); setOpenDropdown(null); }}>MFA Not Registered</li>
          <li onClick={() => { handleChange('account_type', 'deleted'); setOpenDropdown(null); }}>Deleted Accounts</li>
        </ul>
      )}
    </div>
        )}
        <div className="sort-controls">
      <div className="custom-select-container">
        <div 
          className={`filter-select ${openDropdown === 'sort' ? 'active' : ''}`}
          onClick={() => setOpenDropdown(openDropdown === 'sort' ? null : 'sort')}
        >
          {/* Mapping value to label for display */}
          {filters.sortBy === 'displayName' ? 'Name' : filters.sortBy === 'type' ? 'Type' : 'Risk Score'}
        </div>

        {openDropdown === 'sort' && (
          <ul className="scrollable-options">
            <li onClick={() => { handleChange('sortBy', 'displayName'); setOpenDropdown(null); }}>Name</li>
            <li onClick={() => { handleChange('sortBy', 'type'); setOpenDropdown(null); }}>Type</li>
            <li onClick={() => { handleChange('sortBy', 'riskScore'); setOpenDropdown(null); }}>Risk Score</li>
          </ul>
        )}
      </div>

      <button
        className="sort-order-btn"
        onClick={handleSortToggle}
        title={filters.sortOrder === 'asc' ? 'Ascending' : 'Descending'}
      >
        {filters.sortOrder === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
      </button>
    </div>
      </div>
    </div>
  );
};

export default IdentityFilters;